import { render, staticRenderFns } from "./SellerAccountMissingOffers.vue?vue&type=template&id=1b80bf77"
import script from "./SellerAccountMissingOffers.vue?vue&type=script&lang=js"
export * from "./SellerAccountMissingOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports